import { usePrintOrderEnabled } from '../../hooks/use-print-order-enabled';
import { useRestoreActiveCart } from '../../hooks/use-restore-active-cart';
import { PrintOrderActionBar } from '../action-bar';

/**
 * Self-contained print-order cart entry point for a page: restores the active
 * server cart on mount and renders the floating cart bar. The cart dialogs
 * (preview, customize, location) open imperatively through the global
 * `DialogProvider` in the main layout, so mounting this component is all a
 * page needs — used on Resources and Home for an identical cart flow.
 *
 * Mount it once at the page/route root, OUTSIDE any lazily re-mounted content,
 * so the restore call runs on real page entry rather than on inner navigation.
 *
 * Everything is gated behind `usePrintOrderEnabled` (the `shoppingCart` LD
 * flag, never in Outlook mode): without it the restore API never fires and
 * nothing renders.
 */
export const PrintOrderCart = () => {
  const printOrderEnabled = usePrintOrderEnabled();

  useRestoreActiveCart();

  if (!printOrderEnabled) return null;

  return <PrintOrderActionBar />;
};
